import React from "react";
import CartCard from "./CartCard";

const CartPage = () => {
  return (
    <div>
      <CartCard />
    </div>
  );
};

export default CartPage;
